import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const ComboContext = createContext()

const ComboProvider = ({ children }) => {

    const { headers, toast } = useAuth();

    const getAllCombos = async (filter) => {
        try {
            const { limit, totalRenderedRecords, restaurant_id } = filter

            const { data } = await axios.get(`${baseURL}/combos/list?restaurant_id=${restaurant_id ? restaurant_id : null}&limit=${limit ? limit : null}&totalRenderedRecords=${totalRenderedRecords >= 0 ? totalRenderedRecords : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Combo', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createCombo = async (comboDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/combos/create`, comboDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Combo', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Combo', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Combo', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Combo', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Combo', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const getSingleCombo = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/combos/single-combo/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Combo', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const updateCombo = async (id, comboDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/combos/update/${id}`, comboDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Combo', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Combo', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Combo', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Combo', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Combo', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteCombo = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/combos/delete/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Combo', detail: data.message, life: 3000 })
                }, 500);
            } else {
                toast.current?.show({ severity: 'error', summary: 'Combo', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Combo', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <ComboContext.Provider value={{ getAllCombos, createCombo, getSingleCombo, updateCombo, deleteCombo }}>
            {children}
        </ComboContext.Provider>
    )
}

const useCombo = () => useContext(ComboContext)

export { useCombo, ComboProvider }